import { render } from "./ButtonDownload.vue?vue&type=template&id=2dc79234&scoped=true"
import script from "./ButtonDownload.vue?vue&type=script&lang=js"
export * from "./ButtonDownload.vue?vue&type=script&lang=js"

import "./ButtonDownload.vue?vue&type=style&index=0&id=2dc79234&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc79234"]])

export default __exports__